// Logique d'affichage des équipements : tons des états de réservation, semaine précédente et suivante,
// libellé d'une plage, édition des créneaux (ajout, retrait, contrôle des chevauchements par jour).
import { chevauche, ETATS_RESERVATION, JOURS_SEMAINE, type CreneauEquipement, type EtatReservation } from '@cc/contrats';
import type { TonEtat } from '@cc/ui';

export const TON_RESERVATION: Record<EtatReservation, TonEtat> = { demandee: 'signer', a_payer: 'attente', confirmee: 'ok', refusee: 'neutre', annulee: 'neutre', terminee: 'neutre' };
export const libelleEtat = (e: EtatReservation) => ETATS_RESERVATION[e] ?? e;

export function decalerSemaine(lundi: string, semaines: number): string {
  return new Date(Date.parse(`${lundi}T12:00:00Z`) + semaines * 7 * 86_400_000).toISOString().slice(0, 10);
}

export function jourLong(date: string): string {
  return new Date(`${date}T12:00:00Z`).toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' });
}

export const plage = (r: { heure_debut: string; heure_fin: string }) => `${r.heure_debut} à ${r.heure_fin}`;

export const libelleCreneau = (c: CreneauEquipement) => `${JOURS_SEMAINE[c.jour_semaine] ?? c.jour_semaine} ${plage(c)}`;

/** Problèmes d'une liste de créneaux saisie : fin avant début, chevauchement le même jour. */
export function problemesCreneaux(creneaux: readonly CreneauEquipement[]): string[] {
  const p: string[] = [];
  creneaux.forEach((c, i) => {
    if (c.heure_fin <= c.heure_debut) p.push(`${libelleCreneau(c)} : la fin doit suivre le début`);
    creneaux.forEach((d, j) => {
      if (j > i && c.jour_semaine === d.jour_semaine && chevauche(c, d)) p.push(`${libelleCreneau(c)} et ${libelleCreneau(d)} se chevauchent`);
    });
  });
  return p;
}

/** Créneaux triés par jour puis heure de début. */
export function trierCreneaux<T extends CreneauEquipement>(creneaux: readonly T[]): T[] {
  return [...creneaux].sort((a, b) => a.jour_semaine - b.jour_semaine || a.heure_debut.localeCompare(b.heure_debut));
}
